import { Button, Icon } from 'ui'
import PremiumIcon from '/public/s2_icon_premium.svg'
import { PropsWithChildren } from 'react'
import cn from 'classnames'

type Props = {
  onClick?: (e: React.MouseEvent) => void
  className?: string
}

export function FireflyUpgradeButton({
  children,
  className,
  onClick
}: PropsWithChildren<Props>) {
  return (
    <Button
      className={cn('firefly-upgrade-button', className)}
      onClick={onClick}
    >
      <Icon slot="icon">
        <PremiumIcon />
      </Icon>
      {children}
    </Button>
  )
}
